export default "__VITE_ASSET__CHBJsbfM__"